<template>
  <div v-loading="fetchInProgress">
    <template v-if="program">
      <h5>Active program: {{ program.name }}</h5>
      <el-row>
        <el-col :sm="24" :md="8">
          <div class="active-program">
            <div class="main">
              <div class="total">
                <span class="total-count">{{ totalApplicationsCount }}</span>
              </div>
              <div
                class="this-week"
                :class="{ 'text-success': thisWeekApplications.length > 0 }"
              >
                <span class="delta">{{ thisWeekDelta }} this week</span>
              </div>
            </div>
            <p class="caption text-center">Submitted applications</p>
            <router-link
              class="text-center"
              :to="{
                name: 'dashboardOrganizationProgramResults',
                params: { programId: program.id },
              }"
            >
              <el-button class="edit-profile-btn" type="primary" plain>
                Review applications
              </el-button>
            </router-link>
          </div>
        </el-col>
        <el-col :sm="24" :md="16">
          <BarChart
            :height="120"
            :data="applicationsData"
            title="Applications"
          />
        </el-col>
      </el-row>
    </template>

    <template v-else>
      <h4>No active program</h4>
      <router-link
        class="text-center"
        :to="{ name: 'dashboardOrganizationProgramList' }"
      >
        <el-button class="edit-profile-btn" type="primary" plain>
          Edit programs
        </el-button>
      </router-link>
    </template>
  </div>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import { mapState } from 'vuex'

const State = {
  DRAFT: 'darft',
  SUBMITTED: 'submitted',
}

export default {
  components: { BarChart },
  props: {
    organization: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    window.vm = this
  },
  computed: {
    ...mapState('organizationProgramApplications', {
      allApplications: 'applications',
      fetchInProgress: 'fetchInProgress',
    }),
    applications() {
      return this.allApplications.filter((a) => a.state === State.SUBMITTED)
    },
    applicationsData() {
      return this.applications.map((a) => {
        return {
          name: 'Application',
          ts: a.submitted_at,
        }
      })
    },
    drafts() {
      return this.allApplications.filter((a) => a.state === State.DRAFT)
    },
    program() {
      // return null
      return this.organization.active_program
    },
    title() {
      if (!this.program) return
      return this.program
    },
    thisWeekApplications() {
      const weekStart = moment().startOf('isoWeek')
      return this.applications.filter(
        (a) => moment(a.submitted_at) >= weekStart,
      )
    },
    thisWeekDelta() {
      const count = this.thisWeekApplications.length
      if (count > 0) {
        return `+${count}`
      } else {
        return '0'
      }
    },
    totalApplicationsCount() {
      return this.applications.length
    },
  },
  watch: {
    program: {
      immediate: true,
      handler() {
        console.log(' => org:', this.program)
        if (this.program) {
          this.fetchProgramApplications({
            organizationId: this.organization.id,
            programId: this.program.id,
          })
        }
      },
    },
  },
  methods: {
    fetchProgramApplications({ organizationId, programId }) {
      this.$store.dispatch('organizationProgramApplications/fetch', {
        organizationId,
        programId,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.active-program {
  padding: 15px 0;
  display: flex;
  flex-direction: column;

  .main {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 15px;
    // font-family: "Roboto";

    .total {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      .total-count {
        font-size: 50px;
        line-height: 40px;
        font-weight: 500;
        padding-right: 10px;
      }
    }

    .this-week {
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
</style>
